module.exports = __webpack_public_path__ + "img/logo.c3d986db.png";